import { getToken } from './cache'
import { BASEURL } from './realmName'
import encryption from './encryption'

export const announcementStorageKey = 'pc_home_announcement_seen'
let memory = {}
function context() { return JSON.stringify([BASEURL(), encryption.hex_encryption(getToken() || 'guest')]) }
function day() { return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Shanghai' }) }
function read() {
  try {
    const raw = window.localStorage.getItem(announcementStorageKey)
    if (!raw) return memory
    const value = JSON.parse(raw)
    return value && typeof value === 'object' && !Array.isArray(value) ? value : memory
  } catch (_) { return memory }
}
function write(value) { memory = value; try { window.localStorage.setItem(announcementStorageKey, JSON.stringify(value)) } catch (_) { /* Keep same-page suppression if storage is unavailable. */ } }
export function shouldShowAnnouncement() { return read()[context()] !== day() }
export function markAnnouncementShown() {
  const today = day(), value = Object.fromEntries(Object.entries(read()).filter(([, date]) => date === today))
  value[context()] = today; write(value)
}
export function resetAnnouncementForLogin() { const value = read(); delete value[context()]; write(value) }
export function resetAnnouncements() { memory = {}; window.localStorage.removeItem(announcementStorageKey) }
